const TITLES_OPTIONS = {
  REPORTS: {
    // Embarques
    BOARDING: {
      ENTRIES: {
        REPORT: 'Entradas',
        VALUE:
          'Relatório que mostra todas os embarques realizados e seus dados relacionados. Os filtros de data se aplicam de acordo com a data do embarque.',
      },

      VALUE: {
        REPORT: 'Valor',
        VALUE:
          'Gráfico que mostra a evolução do valor dos embarques ao longo dos dias. Os filtros de data se aplicam de acordo com a data do embarque.',
      },
      BOARDING_BY_LINE: {
        REPORT: 'Embarques por Linha',
        VALUE:
          'Relatório que mostra todas os embarques realizados por linha. Os filtros de data se aplicam de acordo com a data do embarque.',
      },
      SHIPMENT_DISTRIBUTION: {
        REPORT: 'Distribuição de Embarque',
        VALUE:
          'Heatmap que mostra a distribuição dos embarques baseado na latitude e longitude. Os filtros de data se aplicam de acordo com a data do embarque.',
      },
    },
    // Arrecadação
    COLLECTION: {
      RECEIPTS: {
        REPORT: 'Recebimentos',
        VALUE:
          'Relatório que mostra os pagamentos recebidos pelos supervisores do sistema. Os filtros de data se aplicam de acordo com a data do recebimento.',
      },
      ONBOARD_SALES: {
        REPORT: 'Vendas à Bordo',
        VALUE:
          'Relatório que mostra os pagamentos e transações realizadas pelos motoristas, à bordo. Os filtros de data podem ser customizado, sendo a data da transação ou da viagem.',
      },
      SALES_NETWORK: {
        REPORT: 'Rede de Vendas',
        VALUE:
          'Relatório que mostra os pagamentos e transações realizadas pelas Redes de Venda. Os filtros de data se aplicam de acordo com a data do recebimento/transação.',
      },
      TRANSPORTATION_VOUCHERS: {
        REPORT: 'Vale Transporte',
        VALUE:
          'Relatório que mostra os pedidos realizaos por VT e Usuários e seus dados. Os filtros de data podem ser customizado, sendo a data da transação ou de pagamento. Para casos de pedidos com impostos relacionados, pode-se verificar o detalhamento dos impostos na aba Impostos.',
      },
      PAYMENT_REQUST: {
        REPORT: 'Requisição Pagamento',
        VALUE:
          'Relatório que exibe todos os pedidos de pagamento da Rede de Venda e seus status. Os filtros de data se aplicam de acordo com a data do pedido.',
      },
      EMV: {
        REPORT: 'BPE',
        VALUE: 'Relatórios Bpe.',
      },
      BPE: {
        REPORT: 'BPE',
        VALUE: 'Relatórios Bilhetagem eletrônica.',
      },
      EMPLOYEE_TRIP_SAP_RESUME: {
        REPORT: 'Viagens de motoristas',
        VALUE: 'Relatório Resumido de Viagens de Motoristas.',
      },
      GRATUITIES: {
        REPORT: 'Gratuidades',
        VALUE: 'Relatório que mostra as gratuidades realizadas',
      },

      OCCURRENCES_IN_EMV: {
        REPORT: 'Ocorrências no EMV • EMV',
        VALUE:
          'Relatórios que mostram os dados relacionados aos pagamentos via EMV. Os filtros de data se aplicam de acordo com a data da transação.',
      },
      SCHOOL_ORDERS_REPORT: {
        REPORT: 'Consolidado de pedidos por Escola',
        VALUE: 'Relatório que mostra o consolidado de pedidos por escola.',
      },
      REPORT_STUDENTS_DEVICE: {
        REPORT: 'Estudantes e Mídias',
        VALUE: 'Relatório que mostra os cartoes e mídias de estudantes.',
      },
      PROFILE_BY_AGE_GROUP: {
        REPORT: 'Perfil por Faixa Etária',
        VALUE:
          'Relatório que exibe a quantidade de embarques por faixa etária. Os filtros de data se aplicam de acordo com a data do embarque.',
      },
      COLLECT: {
        REPORT: 'Coleta',
        VALUE:
          'Relatório que mostra a coleta das viagens e passagens dos DBDs. Os filtros de data se aplicam de acordo com a data da viagem.',
      },
    },
    // Empresas
    COMPANYS: {
      SHOPPING: {
        REPORT: 'Compras',
        VALUE:
          'Relatório que exibe os valores de compra mensal das empresas de VT. Os filtros de data se aplicam de acordo com a data da transação.',
      },
      IMPORTS: {
        REPORT: 'Importações',
        VALUE:
          'Relatório que exibe baixa de pagamentos realizados via arquivos VAN. Os filtros de data se aplicam de acordo com a data da transação.',
      },
    },
    // Utilizações
    UTILICATION: {
      CREDITS_BY_COLLEGE: {
        REPORT: 'Créditos por colégio',
        VALUE:
          'Relatório de detalhes das utilizações por alunos cadastrados nas escolas.',
      },
    },
    // Usuario
    USER: {
      BALANCE: {
        REPORT: 'Saldo',
        VALUE:
          'Relatório referente ao uso e compra de saldo por usuário. O saldo exibido é sempre relativo ao filtro aplicado, de forma que, se necessário verificar saldo total deve-se utilizar filtro desde o início da operação.',
      },
      SUPERIOR_USAGES: {
        REPORT: 'Uso Superiores',
        VALUE:
          'Relatório que exibe quantidade de embarques por mídias dos usuários.',
      },
    },
    // Utilizações
    OPERATION: {
      DEMAND_PER_LINE: {
        REPORT: 'Demanda por Linha',
        VALUE:
          'Relatório que mostra métricas relacionadas às viagens, por linha. Os filtros de data se aplicam de acordo com a data da viagem.',
      },
      QUANTITY_PER_LINE: {
        REPORT: 'Quantidade por Linha',
        VALUE:
          'Relatório que mostra métricas relacionadas às viagens, exceto valores financeiros, por linha. Os filtros de data se aplicam de acordo com a data da viagem.',
      },
      DEMAND_PER_SECTION: {
        REPORT: 'Demanda por Trecho',
        VALUE:
          'Relatório que mostra métricas relacionadas às viagens, por trecho. Os filtros de data se aplicam de acordo com a data da viagem.',
      },
      QUANTITY_PER_SECTION: {
        REPORT: 'Quantidade por Trecho',
        VALUE:
          'Relatório que mostra métricas relacionadas às viagens, exceto valores financeiros, por trecho. Os filtros de data se aplicam de acordo com a data da viagem.',
      },
      DEMAND_PER_DAY: {
        REPORT: 'Demanda por Dia',
        VALUE:
          'Relatório que mostra métricas relacionadas às viagens, por dia. Os filtros de data se aplicam de acordo com a data da viagem.',
      },
      QUANTITY_PER_DAY: {
        REPORT: 'Quantidade por Dia',
        VALUE:
          'Relatório que mostra métricas relacionadas às viagens, exceto valores financeiros, por dia. Os filtros de data se aplicam de acordo com a data da viagem.',
      },
      DEMAND_PER_CAR: {
        REPORT: 'Demanda por Carro',
        VALUE:
          'Relatório que mostra métricas relacionadas às viagens, por carro. Os filtros de data se aplicam de acordo com a data da viagem.',
      },
      QUANTITY_PER_CAR: {
        REPORT: 'Quantidade por Carro',
        VALUE:
          'Relatório que mostra métricas relacionadas às viagens, exceto valores financeiros, por carro. Os filtros de data se aplicam de acordo com a data da viagem.',
      },
      TRIP_HALF: {
        REPORT: 'Meia Viagem',
        VALUE:
          'Relatório que exibe todas as meia viagens (trechos) executados e seus dados, permitindo agrupar por viagem, e agrupado por motorista. Os filtros de data se aplicam de acordo com a data da viagem.',
      },
      OPERATORS_COMMITTEE: {
        REPORT: 'Comissão de Operadores',
        VALUE:
          'Relatório que exibe a comissão dos motoristas de acordo com parametrização definida na configuração de equipe e vendas realizadas.',
      },
      TRAVEL_BY_LINE: {
        REPORT: 'Viagens por Linha',
        VALUE: 'Relatório que exibe a quantidade de viagens e KM por linha.',
      },

      KM_DRIVEN_PER_DAY: {
        REPORT: 'Km Rodados por Dia',
        VALUE:
          'Relatório que exibe a KM rodada por carro por dia. Os filtros de data se aplicam de acordo com a data da viagem.',
      },
      PASSENGERS_TRANSPORTED: {
        REPORT: 'Passageiros Transportados',
        VALUE:
          'Relatório que exibe a quantidade de embarques por mês. Os filtros de data se aplicam de acordo com a data do embarque.',
      },
      KM_RUN: {
        REPORT: 'KM Rodados',
        VALUE:
          'Relatório que exibe a KM rodada por mês. Os filtros de data se aplicam de acordo com a data da viagem.',
      },
      PASSAGERS_BY_TIME_SLOT: {
        REPORT: 'Passageiros por Faixa Horária',
        VALUE:
          'Relatório que exibe a quantidade de embarques por faixa horária. Os filtros de data se aplicam de acordo com a data do embarque.',
      },
      PASSENGERS_TRANSPORTED_OLD: {
        REPORT: 'Relatório Passageiros Transportados',
        VALUE:
          'Relatório que sumariza entradas por agrupamento de Perfis. Este relatório, por realizar agrupamento de perfis, não reflete automaticamente os Perfis criados no BDOS e deve ser parametrizado para funcinonar.',
      },
      TRAVEL_SUMMARY: {
        REPORT: 'Resumo de Viagens',
        VALUE:
          'Relatório que exibe as viagens e seus detalhes. Os filtros de data se aplicam de acordo com a data da viagem.',
      },
      PASSAGERS_TRANSPORTED_BY_ORIGIN: {
        REPORT: 'Passageiros Transportados por Origem',
        VALUE:
          'Relatório que exibe o número de embarque por local de origem e perfil. Os filtros de data se aplicam de acordo com a data do embarque.',
      },
      PASSAGERS_BY_TIME_SLOT_OR_PROFILE: {
        REPORT: 'Passageiros por Faixa Horária / Perfil',
        VALUE:
          'Relatório que exibe a quantidade de embarques por faixa horária e perfil. Os filtros de data se aplicam de acordo com a data do embarque.',
      },
    },
  },
  OPERATION: {
    TOLLS: {
      TITLE: 'Pedágios',
      VALUE:
        'Este módulo é destinado ao registro de pedágios rodoviários presentes nas rotas das linhas.',
    },
  },
};

export default TITLES_OPTIONS;
export { TITLES_OPTIONS };
